module.exports = __webpack_public_path__ + "img/boy.2ad94e1a.svg";